export class BaseModel {
  id: number;
  version?: number;
  flagValid?: boolean;
}
